export default () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.746 1C9.357 1 9.017 1.214 8.854 1.553C8.544 2.187 7.622 2.187 7.312 1.553C7.149 1.214 6.809 1 6.42 1H4C3.447 1 3 1.447 3 2V4.5C3 4.776 2.776 5 2.5 5C1.672 5 1 5.672 1 6.5C1 7.328 1.672 8 2.5 8C2.776 8 3 8.224 3 8.5V14C3 14.553 3.447 15 4 15H12C12.553 15 13 14.553 13 14V10.5C13 10.224 13.224 10 13.5 10C14.328 10 15 9.328 15 8.5C15 7.672 14.328 7 13.5 7C13.224 7 13 6.776 13 6.5V2C13 1.447 12.553 1 12 1H9.746ZM12 2H9.746C9.691 2 9.644 2.032 9.621 2.08C9.283 2.78 8.11 2.78 7.772 2.08C7.749 2.032 7.702 2 7.647 2H6.42H4V4.5C4 5.329 3.329 6 2.5 6C2.224 6 2 6.224 2 6.5C2 6.776 2.224 7 2.5 7C3.329 7 4 7.671 4 8.5V14H12V10.5C12 9.671 12.671 9 13.5 9C13.776 9 14 8.776 14 8.5C14 8.224 13.776 8 13.5 8C12.671 8 12 7.329 12 6.5V2Z'
      fill='#5A607F'
    />
  </svg>
);
